// SAT (Vitrin/SATIN-AL-SELF-SERVIS-PLANI.md): hepy.app fiyat sayfasındaki seçim
// (panel.hepy.app/kayit?paket=basic,teklifbox&ek=13:2,7:1&donem=Aylik) oturum boyunca taşınır:
// /kayit ya da girişten sonra /lisans/satinal (PaketSecimi) seçimi hazır açar, sipariş
// gönderilince silinir. sessionStorage: yalnız bu sekme, tarayıcı kapanınca biter.
const ANAHTAR = "hepySecim";
// DSA (DemoVitrin/DEMO-SATIN-AL-DSA-PLANI.md): demodan gelen tek kullanımlık geçiş anahtarı
// (/kayit?demo=...). Kayıt formunu hazır doldurur; varken girişten sonra da /lisans/satinal açılır.
const DEMO = "hepyDemoGecis";

const kodListesi = (v) => String(v || "")
  .split(",")
  .map((k) => k.trim().toLowerCase())
  .filter((k) => /^[a-z0-9_-]{1,40}$/.test(k));

export function secimiSorgudanKaydet(query) {
  const q = query || {};
  const paket = kodListesi(q.paket);
  // YNL1-2: /lisans/satinal?uzat=<lisansKod> — süresi uzatılacak lisans(lar); o lisansın paketi seçilir.
  const uzat = kodListesi(q.uzat);
  const ek = String(q.ek || "")
    .split(",")
    .map((p) => p.split(":"))
    .filter(([id, adet]) => /^\d{1,9}$/.test(id || "") && (!adet || /^\d{1,4}$/.test(adet)))
    .map(([id, adet]) => ({ pEk: String(Number(id)), Miktar: String(Number(adet || 1) || 1) }));
  const donem = String(q.donem || "").toLowerCase() === "yillik" ? "Yillik" : "Aylik";
  if (!paket.length && !ek.length && !uzat.length) return null;
  const secim = { paket, ek, donem, uzat };
  try { sessionStorage.setItem(ANAHTAR, JSON.stringify(secim)); } catch (e) { /* özel mod */ }
  return secim;
}

export function secimOku() {
  try {
    const s = JSON.parse(sessionStorage.getItem(ANAHTAR) || "null");
    return s && (Array.isArray(s.paket) || Array.isArray(s.ek) || Array.isArray(s.uzat)) ? s : null;
  } catch (e) {
    return null;
  }
}

export function secimVarMi() {
  return !!secimOku() || !!demoGecisOku();
}

export function secimTemizle() {
  try { sessionStorage.removeItem(ANAHTAR); } catch (e) { /* yok */ }
  demoGecisTemizle();
}

export function demoGecisKaydet(anahtar) {
  const a = String(anahtar || "");
  if (!/^[A-Za-z0-9_-]{20,100}$/.test(a)) return;
  try { sessionStorage.setItem(DEMO, a); } catch (e) { /* özel mod */ }
}

export function demoGecisOku() {
  try { return sessionStorage.getItem(DEMO) || ""; } catch (e) { return ""; }
}

export function demoGecisTemizle() {
  try { sessionStorage.removeItem(DEMO); } catch (e) { /* yok */ }
}
